<template>
    <div class="compartilhe">
        <div class="bg-verde">
            <div class="conteudo">
                <label data-aos="fade-right" data-aos-duration="1000" class="t1">Compartilhe!</label>
                <div data-aos="fade-right" data-aos-duration="1000" class="linha"></div>
                <label data-aos="fade-right" data-aos-duration="1000" class="t2">Nunca foi tão fácil mostrar a sua paixão por plantas. Com o Planti você tem uma diversidade de flora na palma da mão.</label>
                <a href="https://apps.apple.com/br/app/planti/id1533612038" target="_blank"><img data-aos="fade-right" data-aos-duration="1000" class="loja1" src="../../assets/images/app-store.svg" alt=""></a>
                <a href="https://play.google.com/store/apps/details?id=com.misie.planti" target="_blank"><img data-aos="fade-right" data-aos-duration="1000" class="loja2" src="../../assets/images/google-play.svg" alt=""></a>
                <img data-aos="fade-up" data-aos-duration="1000" class="celular" src="../../assets/images/celular3.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Compartilhe',
}
</script>

<style scoped lang="scss">

.compartilhe{
    position: relative;
}

.bg-verde{
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 540px;
    background: linear-gradient(261.1deg, #93F9B9 0%, #59C993 100%);
}

.conteudo{
    position: relative;
    background-color: #697aa400;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    max-width: 1300px;
    height: 570px;
}

.t1{
    position: absolute;
    width: 446px;
    left: 105px;
    top: 119px;
    font-style: normal;
    font-weight: normal;
    font-size: 45px;
    line-height: 50px;
    letter-spacing: 1.3px;
    color: #FFFFFF;
}

.linha{
    position: absolute;
    width: 195px;
    height: 0px;
    left: 105px;
    top: 188px;
    border: 1px solid #FFFFFF;
}

.t2{
    position: absolute;
    width: 566px;
    left: 105px;
    top: 230px;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 36px;
    letter-spacing: 1.1px;
    color: #FFFFFF;
}

.loja1{
    position: absolute;
    width: 109.5px;
    left: 105px;
    top: 360px;
}

.loja2{
    position: absolute;
    width: 126px;
    left: 235px;
    top: 360px;
}

.celular{
    position: absolute;
    width: 510px;
    left: 729px;
    top: 39.5px;
}


@media screen and (max-width: 1365px) {
    .bg-verde{
        height: 39.6vw;
    }
    .celular{
        width: 37.5vw;
        left: 53.5vw;
    }

    .t1{
        width: 54.4vw;
        top: 8.8vw;
        left: 7.5vw;
        font-size: 3.3vw;
        line-height: 3.55vw;
        letter-spacing: 1.2px;
    }
    .linha{
        width: 14.1vw;
        left: 7.5vw;
        top: 13.8vw;
    }
    .t2{
        width: 40.3vw;
        height: 112px;
        top: 16.8vw;
        left: 7.5vw;
        font-size: 1.6vw;
        line-height: 2.7vw;
    }
    .loja1{
        top: 26.3vw;
        left: 7.5vw;
    }
    .loja2{
        top: 26.3vw;
    }
}

@media screen and (max-width: 1116px) {
    .conteudo{
        max-width: 860px;
    }
    .celular{
        width: 419px;
        left: 458px;
    }
    .bg-verde{
        height: 442px;
    }
    .t1{
        width: 270px;
        top: 98px;
        left: 0;
        font-size: 36.8px;
        line-height: 39px;
        letter-spacing: 1.2px;
    }

    .linha{
        width: 157px;
        left: 0;
        top: 154px;
    }

    .t2{
        width: 451px;
        top: 187.6px;
        left: 0;
        font-size: 17.8px;
        line-height: 30px;
    }
    .loja1{
        top: 293.5px;
        left: 0;
    }
    .loja2{
        top: 293.5px;
        left: 200px;
    }
}

@media screen and (max-width: 910px) {
    .celular{
        //display: none;
        top: 240px;
        left: 325px;
        width: 270px;
    }
    .bg-verde{
        height: 505px;
    }
    .conteudo{
        max-width: 615px;
    }
    .t1{
        top: 34px;
        width: 100%;
        text-align: center;
    }
    .linha{
        width: 157px;
        left: 230px;
        top: 90px;
    }

    .t2{
        top: 125px;
        left: 46px;
        width: 528px;
        text-align: center;
    }
    .loja1{
        top: 291px;
        left: 97px;
        width: 125px;
    }
    .loja2{
        top: 368px;
        left: 97px;
        width: 125px;
    }
}

@media screen and (max-width: 767px) {
    .bg-verde{
        height: 444px;
    }

    .conteudo{
        max-width: 380px;
    }
    .t1{
        top: 34px;
        left: 126px;
        width: 161px;
        font-size: 22px;
        line-height: 36px;
        text-align: center;
    }
    .linha{
        width: 130px;
        left: 140px;
        top: 70px;
    }

    .t2{
        top: 96px;
        left: 28px;
        width: 338px;
        font-size: 17px;
        line-height: 29px;
        text-align: center;
    }
    .loja1{
        top: 290px;
        left: 30px;
        width: 107px;
    }
    .loja2{
        top: 336px;
        left: 30px;
        width: 107px;
    }
    .celular{
        top: 234px;
        left: 171px;
        width: 215px;
    }
}
//
//@media screen and (max-width: 450px) {
//    .bg-verde{
//        height: 444px;
//    }
//
//    .conteudo{
//        max-width: 380px;
//    }
//    .t1{
//        width: 352px;
//        left: 0;
//        top: 90px;
//        font-size: 28px;
//        line-height: 33px;
//        text-align: center;
//    }
//
//    .t2{
//        width: 352px;
//        height: 128px;
//        left: 0;
//        top: 203px;
//        font-size: 18px;
//        line-height: 28px;
//        text-align: center;
//    }
//    .loja1{
//        top: 350px;
//        left: 35px;
//    }
//    .loja2{
//        top: 350px;
//        left: 175px;
//    }
//}

</style>
